import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import HTTPBackend, { HttpBackendOptions } from 'i18next-http-backend';

export const supportedLanguages = ['en', 'en-ca', 'en-gb', 'de-de', 'es-es', 'fr-ca', 'fr-fr', 'ro-ro'];

// Extract build hash from CRA's main bundle for cache-busting, or use timestamp in dev
const buildHash = (() => {
  const script = document.querySelector('script[src*="/static/js/main."]');
  const match = script?.getAttribute('src')?.match(/main\.([a-f0-9]+)\.js/);
  return match?.[1] ?? String(Date.now());
})();

i18next
  .use(HTTPBackend)
  .use(new ICU())
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    load: 'currentOnly',
    lowerCaseLng: true,
    debug: process.env.NODE_ENV !== 'production',
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: buildHash },
    },
  });

// Throw when a key doesn't exist (only after translations are loaded)
i18next.on('loaded', () => {
  const baseT = (i18next.t as any).bind(i18next);
  i18next.t = ((key: any, ...args: any[]) => {
    const opts = args[0];
    const hasDefault = opts && typeof opts === 'object' && 'defaultValue' in opts;
    const ns = (opts && (opts.ns as string)) || (i18next.options.defaultNS as string) || 'translation';
    const lang = i18next.language;
    const bundleLoaded = Boolean(lang && i18next.hasResourceBundle(lang, ns));
    if (!hasDefault && bundleLoaded && !i18next.exists(key, opts)) {
      throw new Error(`Missing i18n key: "${key}"`);
    }
    return baseT(key, ...args);
  }) as any;
});

const DEBUG_I18N = false;
if (DEBUG_I18N) {
  const origT = i18next.t;
  const debugT = ((key: any, ..._args: any[]) => key) as unknown as typeof origT;
  Object.assign(debugT, origT);
  i18next.t = debugT;
}

export default i18next;
